import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'No products yet.',
  fields: {
    number: '#',
    image: 'Image',
    name: 'Name',
    external_id: '{{integration}} ref',
    price: 'Price',
    prices: 'Prices',
    description: 'Description',
    tags: 'Tags',
    status: 'Status',
    product_type: 'Type',
    statuses: {
      good: 'Good',
      bad: 'Bad',
      medium: 'Medium',
    },
    product_types: {
      packaged: 'Packaged',
      prepared: 'Prepared',
    },
  },
  labels: {
    visible: 'Visible in menu',
    hidden: 'All hidden',
  },
  order_method_prices: {
    base: 'Base',
    [ORDER_METHODS.pickup]: 'Pickup',
    [ORDER_METHODS.delivery]: 'Delivery',
    [ORDER_METHODS.on_site]: 'Table ordering',
  },
  buttons: {
    delete_products_one: 'Delete product',
    delete_products_other: 'Delete products',
    add_product: '+ Add product',
    show_products: 'Show products',
    hide_products: 'Hide products',
    add: 'Add',
    edit: 'Edit',
    duplicate: 'Duplicate',
    history: 'History',
    delete: 'Delete',
    delete_all: 'Delete all',
  },
  toasts: {
    failed_to_duplicate_category: 'Failed to duplicate category',
    category_duplicated_successfully: 'Category duplicated successfully',
    failed_to_duplicate_product: 'Failed to duplicate product',
    product_duplicated_successfully: 'Product duplicated successfully',
    failed_to_delete_variant: 'Failed to delete variant',
    variant_got_deleted: 'Variant got deleted',
    something_went_wrong: 'Something went wrong',
  },
};
